import { render, staticRenderFns } from "./header.vue?vue&type=template&id=50b3406a&scoped=true"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&id=50b3406a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3406a",
  null
  
)

export default component.exports